import { registerHandle, resolve, summarizeRef } from '@/agent/refs';
import { useSelectionStore } from '@/state/selectionStore';
import { translateAttributes } from './shared/layers';
import { findLayer } from '@/map/layers/registry';
import type { Tool } from './types';

export const getSelection: Tool<Record<string, never>> = {
  name: 'get_selection',
  description:
    "Return the user's currently click-selected feature, or null if nothing is selected. No arguments. Subsequent tools can reference it via { kind: 'selection' } or via the returned handle.",
  input_schema: {
    type: 'object',
    properties: {},
    additionalProperties: false,
  },
  execute: async () => {
    const sel = useSelectionStore.getState().current;
    if (!sel) return { feature: null };
    const ref = await resolve({ kind: 'selection' });
    const handle = registerHandle(ref);
    const probe = findLayer(sel.layer_id)?.probe;
    return {
      handle,
      summary: summarizeRef(ref),
      feature: {
        layer_id: sel.layer_id,
        objectid: sel.objectid,
        display: sel.display ?? null,
        centroid: sel.centroid ?? null,
        attributes: translateAttributes(sel.attributes, probe),
      },
    };
  },
};
